import React from "react";
import { Route, Switch } from "react-router-dom";
import ErrorBoundry from "./components/errorBoundry/errorBoundry";
import Sidebar from "./components/sidebar/sidebar";
import Search from "./components/search/search";
import Popular from "./components/pages/popular";
import Playing from "./components/pages/playing";
import Upcoming from "./components/pages/upcoming";
import Favorites from "./components/pages/favorites";
import Details from "./components/pages/details";
import MobileMenu from "./components/mobileMenu/mobileMenu";
const App = () => {
  return (
    <ErrorBoundry>
      <div className="container">
        <div className="side-bar">
          <Sidebar />
        </div>
        <div className="content">
          <Search />
          <MobileMenu />
          <Switch>
            <Route path="/" component={Popular} exact />
            <Route path="/upcoming" component={Upcoming} />
            <Route path="/playing" component={Playing} />
            <Route path="/favorites" component={Favorites} />
            <Route
              path="/details/:id"
              render={({ match }) => {
                const id = match.params.id;
                return <Details idMovie={id} />;
              }}
            />
            <Route path="" render={() => <h2>Page not found</h2>} />
          </Switch>
        </div>
      </div>
    </ErrorBoundry>
  );
};

export default App;
